import * as React from 'react';

import { createNavigationContext, createNavMenu } from "@tdp/common/detailsNavigation";

const [useBotDetailsNavigationRoutes, createRoutes] = createNavigationContext<{
  // This will be more precisely defined as a type in a future PR
  title: React.ReactNode
}>();

export { createRoutes };
export const BotDetailsNavBar = createNavMenu({
  hook: useBotDetailsNavigationRoutes,
  renderNavItem: (item) => item.data?.title ?? 'Missing Route Title',
});
